import React from "react";
import axios from "axios";
import Header from "../Components/header";

import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useCallback, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;

const stripePromise = loadStripe(STRIPE_API_KEY);

//TODO in production non vede la chiave di stripe

const API_URL = process.env.REACT_APP_API_URL;

const CheckoutForm = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [isLogged, setIsLogged] = useState(true);
  const location = useLocation();
  const data = location.state?.data || {};
  //const { isGift, id_prodotto } = data;

  useEffect(() => {
    const fetchClientSecret = async () => {
      console.log(process.env);

      console.log(process.env.REACT_APP_STRIPE_API_KEY);

      console.log("API_KEY, ", STRIPE_API_KEY);
      try {
        axios.defaults.withCredentials = true;
        const response = await axios.post(
          `${API_URL}/create-checkout-session`,
          {
            data,
          }
        );
        console.log(response);
        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error("Error creating payment intent:", error);
        if (error.response && error.response.status === 401) {
          setIsLogged(false);
        }
      }
    };
    fetchClientSecret();
  }, []);
  const options = { clientSecret };

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const SubscribeCheckoutForm = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [isLogged, setIsLogged] = useState(true);
  const location = useLocation();
  const data = location.state?.data;
  const rivista = location.state?.rivista;
  const previousLocation = location.state?.from || "/";

  useEffect(() => {
    console.log("Location state: ", location.state);
    console.log("Previous Location PROVA:", previousLocation);
    const fetchClientSecret = async () => {
      console.log("RIVISTA:", rivista);
      try {
        axios.defaults.withCredentials = true;
        console.log(data);
        const response = await axios.post(`${API_URL}/subscribe`, {
          id_prodotto: data.id_rivista,
          selectedOption: data.selectedOption,
          ...(data.coupon && { coupon: data.coupon }), // Se `coupon` esiste, lo aggiunge all'oggetto `data`
        });
        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error("Error creating payment intent:", error);
        if (error.response && error.response.status === 401) {
          setIsLogged(false);
        }
      }
    };
    fetchClientSecret();
  }, []);
  const options = { clientSecret };

  if (!isLogged) {
    //return <Navigate to="/login" state={{ from: location }} />;
    console.log("PREVIOUS LOCATION:", previousLocation);
    return <Navigate to="/login" state={{ from: previousLocation }} />;
  }

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const RinnovoCheckoutForm = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [isLogged, setIsLogged] = useState(true);
  const location = useLocation();
  const data = location.state?.data;

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        axios.defaults.withCredentials = true;
        console.log(data);
        const response = await axios.post(`${API_URL}/rinnovo`);

        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.log("QUI");
        console.error("Error creating payment intent:", error);
        if (error.response && error.response.status === 401) {
          setIsLogged(false);
        }

        if (error.response && error.response.status === 400) {
          setErrorMessage(error.response.data.error);
        }
      }
    };
    fetchClientSecret();
  }, []);

  const options = { clientSecret };

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (errorMessage) {
    return (
      <div>
        <Header />
        <h2 className="mt-10 font-bolder text-3xl">{errorMessage}</h2>
      </div>
    );
  }
  return (
    <div id="checkout">
      <Header />
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    const fetchSessionStatus = async () => {
      try {
        axios.defaults.withCredentials = true;
        const response = await axios.get(
          `${API_URL}/session-status?session_id=${sessionId}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        console.log(response);
        setStatus(response.data.status);
        setCustomerEmail(response.data.customer_email);
      } catch (error) {
        setError(error);
        console.error("ERRORE:", error.response.data);
      }
    };

    if (sessionId) {
      fetchSessionStatus();
    }
  }, []);

  if (error) {
    return (
      <section id="success" style={{ textAlign: "center", padding: "20px" }}>
        <iframe src="https://lottie.host/embed/2fcfd446-ae39-41bb-9c33-d1374e1f2fc8/EzSQDWHH9t.json"></iframe>{" "}
        <h2 className="text-4xl font-bold">Error</h2>
        <p>
          An error occurred while processing your payment. Please try again
          later.
        </p>
        <p>
          If you continue to experience issues, please contact our support team
          at <a href="mailto:support@example.com">support@example.com</a>.
        </p>
        <a
          href="/"
          className="bg-blue-500 text-white px-4 py-3 mt-5 rounded inline-block
          hover:bg-blue-600 no-underline transition-colors"
        >
          Return to home
        </a>
      </section>
    );
  }

  if (status === "open") {
    return <Navigate to="/checkout" />;
  }

  if (status === "complete") {
    return (
      <section
        id="success"
        className="flex flex-col items-center h-screen bg-gray-50"
      >
        <div className="w-full max-w-lg bg-resd-500">
          <DotLottieReact
            src="https://lottie.host/cbecb3e6-6b91-44f8-a116-a0741392f5b9/A8eyO43Xod.json"
            loop
            autoplay
            autoResizeCanvas
            className="w-60 h-60 mx-auto"
          />
        </div>
        <h2>Thank You for Your Purchase!</h2>
        <p>
          Your payment was successfully processed. A confirmation email has been
          sent to <strong>{customerEmail}</strong>.
        </p>
        <p>
          If you have any questions or need further assistance, feel free to
          contact our support team at{" "}
          <a href="mailto:support@example.com">support@example.com</a>.
        </p>
        <p>
          You can view your order details or track your shipment through the
          link provided in the confirmation email.
        </p>
        <p>We appreciate your business and hope to see you again soon!</p>
        <a
          href="/"
          className="bg-blue-500 text-white px-4 py-3 mt-5 rounded inline-block
          hover:bg-blue-600 no-underline transition-colors"
        >
          {" "}
          Return to home
        </a>
      </section>
    );
  }

  return null;
};

export default CheckoutForm;
